import "./AboutUs.css";
import headerBg from "../Images/AbouUsImage.png";
import studentOne from "../Images/ShaanImg.webp";
import studentTwo from "../Images/PrionkariImg.webp";
import studentThree from "../Images/SadiaImg.webp";
import React, {useState, useRef, useEffect} from 'react';
import logger from "../Components/Logger";


// Source code https://stackoverflow.com/questions/59595700/how-to-make-a-react-component-fade-in-on-scroll-using-intersectionobserver-but 
// + ChatGPT fixing small bugs in layout.
const FadeInSection = ({ children }) => {
  const domRef = useRef(null);
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    // Create an IntersectionObserver to detect when the component is in the viewport and trigger the fade-in animation,
    // with added logging for debugging visibility changes and observer status.
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setVisible(true);
        observer.unobserve(domRef.current);
        logger.info("FadeInSection is now visible on the screen.");
      } else {
        logger.debug("FadeInSection is not visible yet.");
      }
    });
    // Start observing the component when it mounts, with a check to ensure the ref is attached and logging for observer status.
    if (domRef.current) {
      observer.observe(domRef.current);
      logger.info("IntersectionObserver is now observing the FadeInSection component.");
    } else {
      logger.warn("FadeInSection component is not mounted yet, cannot observe.");
    }
    // Clean up the observer when the component unmounts to prevent memory leaks, with logging to confirm cleanup.
    logger.info("IntersectionObserver has been disconnected from the FadeInSection component.");
    return () => observer.disconnect() ;
  }, []);

  return (
    <section
      ref={domRef}
      className={`fade-section ${isVisible ? "is-visible" : ""}`}
    >
      {children}
    </section>
  );
};

export function AboutUs({ t }) {

  const services = [
    { title: t.ClassOf8, desc: t.ClassOf8Desc },
    { title: t.OneOnOne, desc: t.OneOnOneDesc },
    { title: t.HighSchoolExams, desc: t.HighSchoolExamsDesc },
    { title: t.AdmissionExams, desc: t.AdmissionExamsDesc },
  ];

  const values = [
    { icon: "🫂", title: t.Respect, desc: t.RespectDesc },
    { icon: "🤝", title: t.Trust, desc: t.TrustDesc },
    { icon: "👥", title: t.Community, desc: t.CommunityDesc },
    { icon: "👐", title: t.Inclusion, desc: t.InclusionDesc },
  ];

  return (
    <div>
      <section className="Header">
        <img
          className="Image-Background"
          src={headerBg}
          alt="Background decoration"
        />
        <h1>{t.AboutUs}</h1>
        <span className="highlight">{t.Highlight}</span>
        <p>{t.Intro}</p>
      </section>

      <div className="Main-AboutUs">
        
      <section className="fadeEx">
        <FadeInSection>
        <section className="top-two-section">
          <div className="aboutUs-Section">
            <h2>{t.Title1}</h2>
            <p>{t.Content1}</p>
          </div>
          <div className="aboutUs-Section">
            <h2>{t.Title2}</h2>
            <p>{t.Content2}</p>
          </div>
        </section>
        </FadeInSection>

      <FadeInSection>
          <h2 className="services-title">{t.OurServices}</h2>
          <section className="services-section">
            {services.map((service, idx) => (
              <div key={idx} className="service-card">
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
              </div>
            ))}
          </section>
        </FadeInSection>

      <FadeInSection>
          <h2 className="values-title">{t.CoreValues}</h2>
          <section className="values-section">
            {values.map((val, idx) => (
              <div key={idx} className="value-card">
                <span className="icon">{val.icon}</span>
                <h3>{val.title}</h3>
                <p>{val.desc}</p>
              </div>
            ))}
          </section>
        </FadeInSection>
      </section>

      <FadeInSection>
        <h2 className="values-title"> Student Testimonials </h2>
        <span className="testimonialIntro">{t.TestimonialIntro}</span>
      </FadeInSection>

      <FadeInSection>
        <section>
          <div className="testimonial">
            <img src={studentOne} alt="ShaanImg" />

            <div className="testimonialText">
              <h2 className="noTranslate" translate="no">Shaan</h2>
              <p>{t.TestimonialShaan}</p>
            </div>
          </div>
        </section>
      </FadeInSection>

      <FadeInSection>
        <section>
          <div className="testimonialRight">
            <img className="photo_texte" src={studentTwo} alt="PrionkariImg" />
            <div className="testimonialName">
              <h2 className="noTranslate" translate="no">Prionkari</h2>
              <p>{t.TestimonialPrionkari}</p>
            </div>
          </div>
        </section>
      </FadeInSection>

      <FadeInSection>
        <section>
          <div className="testimonial">
            <img src={studentThree} alt="SadiaImg" />
            <div className="testimonialText">
              <h2 className="noTranslate" translate="no">Sadia</h2>
              <p>{t.TestimonialSadia}</p>
            </div>
          </div>
        </section>
        </FadeInSection>
      </div>
    </div>
  );
}